import { useMemo } from 'react'

import { useConsultation } from '@/hooks/useConsultation'
import { isConsultationEnded } from '@/utils/consultation'

export const useConsultationEnded = (): boolean => {
  const { consultation } = useConsultation()

  return useMemo(() => {
    if (!consultation) return true

    return isConsultationEnded(consultation)
  }, [consultation?.status])
}
